"use strict";

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var index_exports = {};

__export(index_exports, {
  useControllableState: function useControllableState() {
    return _useControllableState;
  },
  useControllableStateReducer: function useControllableStateReducer() {
    return _useControllableStateReducer;
  }
});

module.exports = __toCommonJS(index_exports); // src/use-controllable-state.tsx

var React = __toESM(require("react"));

var import_react_use_layout_effect = require("@radix-ui/react-use-layout-effect");

var useInsertionEffect = React[" useInsertionEffect ".trim().toString()] || import_react_use_layout_effect.useLayoutEffect;

function _useControllableState(_ref) {
  var prop = _ref.prop,
      defaultProp = _ref.defaultProp,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      caller = _ref.caller;

  var _useUncontrolledState = useUncontrolledState({
    defaultProp: defaultProp,
    onChange: onChange
  }),
      _useUncontrolledState2 = _slicedToArray(_useUncontrolledState, 3),
      uncontrolledProp = _useUncontrolledState2[0],
      setUncontrolledProp = _useUncontrolledState2[1],
      onChangeRef = _useUncontrolledState2[2];

  var isControlled = prop !== void 0;
  var value = isControlled ? prop : uncontrolledProp;

  if (true) {
    var isControlledRef = React.useRef(prop !== void 0);
    React.useEffect(function () {
      var wasControlled = isControlledRef.current;

      if (wasControlled !== isControlled) {
        var from = wasControlled ? "controlled" : "uncontrolled";
        var to = isControlled ? "controlled" : "uncontrolled";
        console.warn("".concat(caller, " is changing from ").concat(from, " to ").concat(to, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
      }

      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }

  var setValue = React.useCallback(function (nextValue) {
    if (isControlled) {
      var value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;

      if (value2 !== prop) {
        var _onChangeRef$current;

        (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 || _onChangeRef$current.call(onChangeRef, value2);
      }
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, setUncontrolledProp, onChangeRef]);
  return [value, setValue];
}

function useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
      onChange = _ref2.onChange;

  var _React$useState = React.useState(defaultProp),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var prevValueRef = React.useRef(value);
  var onChangeRef = React.useRef(onChange);
  useInsertionEffect(function () {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(function () {
    if (prevValueRef.current !== value) {
      var _onChangeRef$current2;

      (_onChangeRef$current2 = onChangeRef.current) === null || _onChangeRef$current2 === void 0 || _onChangeRef$current2.call(onChangeRef, value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}

function isFunction(value) {
  return typeof value === "function";
} // src/use-controllable-state-reducer.tsx


var React2 = __toESM(require("react"));

var import_react_use_effect_event = require("@radix-ui/react-use-effect-event");

var SYNC_STATE = Symbol("RADIX:SYNC_STATE");

function _useControllableStateReducer(reducer, userArgs, initialArg, init) {
  var controlledState = userArgs.prop,
      defaultProp = userArgs.defaultProp,
      onChangeProp = userArgs.onChange,
      caller = userArgs.caller;
  var isControlled = controlledState !== void 0;
  var onChange = (0, import_react_use_effect_event.useEffectEvent)(onChangeProp);

  if (true) {
    var isControlledRef = React2.useRef(controlledState !== void 0);
    React2.useEffect(function () {
      var wasControlled = isControlledRef.current;

      if (wasControlled !== isControlled) {
        var from = wasControlled ? "controlled" : "uncontrolled";
        var to = isControlled ? "controlled" : "uncontrolled";
        console.warn("".concat(caller, " is changing from ").concat(from, " to ").concat(to, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
      }

      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }

  var args = [_objectSpread(_objectSpread({}, initialArg), {}, {
    state: defaultProp
  })];

  if (init) {
    args.push(init);
  }

  var _React2$useReducer = React2.useReducer.apply(React2, [function (state2, action) {
    if (action.type === SYNC_STATE) {
      return _objectSpread(_objectSpread({}, state2), {}, {
        state: action.state
      });
    }

    var next = reducer(state2, action);

    if (isControlled && !Object.is(next.state, state2.state)) {
      onChange(next.state);
    }

    return next;
  }].concat(args)),
      _React2$useReducer2 = _slicedToArray(_React2$useReducer, 2),
      internalState = _React2$useReducer2[0],
      dispatch = _React2$useReducer2[1];

  var uncontrolledState = internalState.state;
  var prevValueRef = React2.useRef(uncontrolledState);
  React2.useEffect(function () {
    if (prevValueRef.current !== uncontrolledState) {
      prevValueRef.current = uncontrolledState;

      if (!isControlled) {
        onChange(uncontrolledState);
      }
    }
  }, [onChange, uncontrolledState, prevValueRef, isControlled]);
  var state = React2.useMemo(function () {
    var isControlled2 = controlledState !== void 0;

    if (isControlled2) {
      return _objectSpread(_objectSpread({}, internalState), {}, {
        state: controlledState
      });
    }

    return internalState;
  }, [internalState, controlledState]);
  React2.useEffect(function () {
    if (isControlled && !Object.is(controlledState, internalState.state)) {
      dispatch({
        type: SYNC_STATE,
        state: controlledState
      });
    }
  }, [controlledState, internalState.state, isControlled]);
  return [state, dispatch];
}